<app-header (selectionChange)="onDropdownChange($event)"></app-header>
<section class="mainSection">
    <div class="container">
        <div class="p-3 p-md-5  mb-5 mt-5">
            <h1 class="mainTitle">
                Gestão {{homeData.startYear}} - {{homeData.endYear}}
            </h1>
            <h1 class="mainTitle">
                Bem-vindo ao painel de indicadores do governo do estado do Espírito Santo
            </h1>
            <div class="row mt-5">
                <div class=" mainHighlight" *ngFor="let item of overViewOrganizer"  [ngClass]="'mainHighlight'+ overViewOrganizer.length">
                    <div class="numberTitle"[countUp]="item.count">0</div>
                    {{ item.count === 1 ? item.name : item.nameInPlural }}
                  </div>
            </div>
            <p class="mt-5 ps-5 pe-5 mainText">Agora você poderá comparar as metas com os resultados alcançados pelos indicadores entre {{homeData.startYear}} a {{homeData.endYear}}</p>
            <div class="text-center mt-5" *ngIf="homeData.organizers">
                <a href="/home#areas" >
                    <i class="fa-solid fa-circle-chevron-down fa-bounce text-white fs-1" style="--fa-animation-duration: 1.8s;--fa-animation-timing:3s;--fa-animation-iteration-count:5"></i>
                </a>
            </div>
        </div>
    </div>
</section>
<section id="areas" #areas *ngIf="homeData.organizers">
    <div class="container mt-3 mb-3 mb-md-5 mt-md-5 pb-md-5 pt-md-5">
        <h1 class="text-center text-dark fontMS-700 ">{{areaName}}</h1>
        <div class="row mt-5">
            <ng-container *ngFor="let eixo of getOrganizersKey()">
                <div class="border-with-text" *ngIf="eixo.length > 0">
                    <span>{{eixo == '' ? '' : eixo}}</span>
                </div>
                <div class="col-lg-4 mb-5" *ngFor="let area of homeData.organizers[eixo]">
                    <div class="card border-light shadow p-3 h-100">
                        <div class="card-title">
                        </div>
                        <div
                            class="card-body cursor-pointer"
                            [routerLink]="['/area']"
                            [queryParams]="{id: area.id}"
                            routerLinkActive="router-link-active"
                            role="button"
                            tabindex="0"
                            >
                            <i class="fa-solid {{area.icon}} iconCard"></i>
                            <h4 class="card-title cursor-default fontMS-700">{{area.name}}</h4>
                            <p class="card-text cursor-default">
                                Área composta por <span class="fw-bold">{{area.challenge}}</span> desafios e
                                <span class="fw-bold">{{area.indicator}}</span> Indicadores Estratégicos
                            </p>
                            <span class="btn btn-link no_underline fontMS-700 adjustBtn">
                                Ver detalhes <i class="fa-solid fa-right-long"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
<!--
            <div class="col-md-4 mt-5">
                <div class="card border-light shadow p-3">
                    <div class="card-title">
                    </div>
                    <div class="card-body">
                        <i class="fa-solid fa-shield-halved iconCard"></i>
                        <h4 class="card-title fontMS-700">Segurança em defesa da Vida</h4>
                        <p class="card-text">
                            <span class="fw-bold">5</span> Desafios<br>
                            <span class="fw-bold">16</span> Indicadores Estratégicos
                        </p>
                        <a href="#" class="btn btn-link no_underline fontMS-700">Ver detalhes  <i class="fa-solid fa-right-long"></i></a>
                    </div>
                </div>
            </div>  -->
        </div>
    </div>
</section>
<app-footer></app-footer>
